import React, { Component } from "react"
import config from "react-global-configuration"
import { getParkingProductUpgradeText, getContentEnrichedProduct } from "../../helpers/bookingHelper"
import * as tracking from "../../helpers/tracking"
import "../../../helpers/strings"

export default class BookingUpsale extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  handleSpecialProductClick = (item, bookingGuid, previousProductName, previousProductId) => {
    const { product } = item

    this.props.setParkingDetailModalState({
      bookingResult: this.props.bookingResult,
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingSpecialProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(item, this.props.content),
      parkingDetailsModalButtonClickOverride: () =>
        this.props.executeUpsaleForBooking(bookingGuid, product.id, previousProductName, previousProductId),
      parkingDetailsModalTrackingEventLabel: "terms accept",
    })
  }

  handleMemberProductClick = (item) => {
    this.props.setParkingDetailModalState({
      bookingResult: this.props.bookingResult,
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingMemberProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(item, this.props.content),
      parkingDetailsModalTrackingEventLabel: "terms accept",
    })
  }

  handleUpsaleDetailsClick = (event, upsaleProduct, previousProductName, previousProductId, upgradePrice, isAmendment = false) => {
    event.preventDefault()
    const upsaleTrackingData = {
      productName: previousProductName,
      productId: previousProductId,
      upsaleProductName: `${this.props.bookingUpsale.product.name} - ${this.props.bookingUpsale.carPark.name}`,
      upsaleProductId: this.props.bookingUpsale.product.id,
      isAmendment: isAmendment,
      upsaleValue: upgradePrice,
    }
    this.props.setDataToState({ upsaleTrackingData: upsaleTrackingData })
    this.props.setParkingDetailModalState({
      bookingResult: this.props.bookingResult,
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingDetailsModalActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(upsaleProduct, this.props.content),
      parkingDetailsModalButtonTextOverride: "Opgradér",
      parkingDetailsModalButtonClickOverride: () =>
        this.props.executeUpsaleForBooking(this.props.bookingResult.booking.guid, upsaleProduct.product.id, previousProductName, isAmendment),
      parkingDetailsModalTrackingEventLabel: "cta click",
    })
  }

  handleBuyClickFunction = (event, item, previousProductName, previousProductId, upgradePrice, isAmendment = false) => {
    event.preventDefault()
    this.props.setDataToState({ ajaxSpinnerActive: true })
    const { product, result } = item

    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const showMemberprice = result?.showMemberPrice

    const { userAccountDetails } = this.props

    const bookingGuid = this.props.bookingResult.booking.guid

    const isLoggedIn = !!userAccountDetails

    // const previousProductName = `${this.props.bookingResult.product.name} - ${this.props.bookingResult.carPark.name}`
    const upsaleTrackingData = {
      productName: previousProductName,
      productId: previousProductId,
      upsaleProductName: `${this.props.bookingUpsale.product.name} - ${this.props.bookingUpsale.carPark.name}`,
      upsaleProductId: this.props.bookingUpsale.product.id,
      isAmendment: isAmendment,
      upsaleValue: upgradePrice,
    }
    this.props.setDataToState({ upsaleTrackingData: upsaleTrackingData })
    if (isSpecialProduct) {
      this.handleSpecialProductClick(item, bookingGuid, previousProductName, previousProductId)
    } else if (showMemberprice && !isLoggedIn) {
      this.handleMemberProductClick(item)
    } else {
      tracking.trackParkingProductUpgrade(this.props, upsaleTrackingData, "cta click", isAmendment)
      this.props.executeUpsaleForBooking(bookingGuid, product.id, previousProductName, isAmendment)
    }
    // isSpecialProduct
    //     ? this.handleSpecialProductClick(item, bookingGuid)
    //     : showMemberprice && !isLoggedIn ? this.handleMemberProductClick(item)
    //         : tracking.trackParkingProductUpgrade(this.props, upsaleTrackingData, "cta click")
    // this.props.executeUpsaleForBooking(bookingGuid, product.id)

    // this.props.executeUpsaleForBooking(this.props.bookingResult.booking.guid, product.id)
  }

  addInnerFormStyle = () => {
    if (this.props.innerForm === true) {
      let elementClass = " innerForm"
      return elementClass
    }
    return ""
  }

  // handleUpsale(event, upsaleProductId) {
  //     event.preventDefault()
  //     console.log(upsaleProductId)
  //     const isSpecialProduct = highlightProduct.product && highlightProduct.product.dynamicFields && highlightProduct.product.dynamicFields.isSpecialProduct
  //     const showMemberprice = result && result.memberPrice && result.memberPrice > 0
  //     const { userAccountDetails } = this.props;
  //     const isLoggedIn = !!userAccountDetails

  //     const handleClickFunction =
  //         isSpecialProduct
  //             ? () => this.handleSpecialProductClick()
  //             : showMemberprice && !isLoggedIn ? () => this.handleMemberProductClick()
  //                 : () => this.props.handleReservation(product.id, this.props.item)

  //     this.props.executeUpsaleForBooking(this.props.bookingResult.booking.guid, upsaleProductId)
  // }

  render() {
    const textKeys = config.get("textKeys.checkout.summary") || {}
    const upsaleHeadline = textKeys.upsaleHeadline || "Opgrader din parkering til {carParkName} {productName} for {price} ekstra"
    const { bookingUpsale, content, bookingResult } = this.props
    const { booking, product, carPark } = bookingResult
    const upgradeProductName = bookingUpsale && bookingUpsale.product.name
    const upgradeCarparkName = bookingUpsale && (upgradeProductName === "We Park You Fly" ? "" : bookingUpsale?.carPark.name)
    const upgradeAmount = bookingUpsale?.result.totalPrice - booking.items.parkings[0].amount
    const upgradePrice = bookingUpsale && this.props.priceFormatter(upgradeAmount)
    const previousProductName = `${product.name} - ${carPark.name}`
    const upgradeButtonText = textKeys.upgradeButtonText || "Opgradér"

    //If product is not a budget product, dont show upsale.
    //https://alphasolutionsdk.atlassian.net/browse/PAR-3143
    if (!product.code.includes("Budget")) return null

    return (
      <div className={`form--parking__calc__upgrade ${this.addInnerFormStyle()}`}>
        <header>
          <h5>{upsaleHeadline.formatUnicorn({ carparkName: upgradeCarparkName, productName: upgradeProductName, price: upgradePrice })}</h5>
          <p>
            {getParkingProductUpgradeText(bookingUpsale?.carPark, bookingUpsale?.product, content) ||
              textKeys.upgradeText?.replace("{carParkName}", upgradeCarparkName).replace("{price}", upgradePrice) ||
              "Du har mulighed for at opgradere til We Park You Fly og komme helt tæt på terminalerne."}
          </p>
        </header>
        <ul>
          {textKeys.upgradeUsps &&
            textKeys.upgradeUsps.map((u, index) => (
              <li key={index}>
                <svg className="svg-icon svg-icon--checkmark">
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark"></use>
                </svg>
                {u}
              </li>
            ))}
        </ul>
        <footer>
          <button
            className="link simple-link"
            onClick={(e) =>
              this.handleUpsaleDetailsClick(e, bookingUpsale, previousProductName, product.id, upgradeAmount, this.props.loadedFromAmendment)
            }
          >
            {textKeys.upgradeReadMore || "Læs mere"}
          </button>
          <button
            className="button button--small button--general"
            onClick={(e) =>
              this.handleBuyClickFunction(e, bookingUpsale, previousProductName, product.id, upgradeAmount, this.props.loadedFromAmendment)
            }
          >
            <span className="text">
              {upgradeButtonText.replace("{carParkName}", bookingUpsale.carPark.name).replace("{productName}", bookingUpsale.product.name)}
            </span>
            {/* <span className="text">{upgradeButtonText.replace("{carParkName}", "".replace("{productName}", bookingUpsale.product.name)}</span> */}
          </button>
        </footer>
      </div>
    )
  }
}
